export default __webpack_public_path__ + "assets/4156e54ec434568fdbdcd5de29903cd2.svg";